var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon blueSVGs",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25032_20308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7067 10.9039L10.197 9.02159V5.18738C10.197 4.80186 9.88541 4.49023 9.49988 4.49023C9.11436 4.49023 8.80273 4.80186 8.80273 5.18738V9.3702C8.80273 9.58979 8.90592 9.79686 9.08159 9.92792L11.8701 12.0193C11.9905 12.11 12.1371 12.1589 12.2877 12.1588C12.5003 12.1588 12.7095 12.0632 12.8461 11.8792C13.0776 11.5717 13.0149 11.1346 12.7067 10.9039Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.314453C4.5371 0.314453 0.5 4.35155 0.5 9.31445C0.5 14.2774 4.5371 18.3145 9.5 18.3145C14.4629 18.3145 18.5 14.2774 18.5 9.31445C18.5 4.35155 14.4629 0.314453 9.5 0.314453ZM9.5 16.9202C5.30674 16.9202 1.89426 13.5077 1.89426 9.31445C1.89426 5.12119 5.30674 1.70871 9.5 1.70871C13.694 1.70871 17.1057 5.12119 17.1057 9.31445C17.1057 13.5077 13.6933 16.9202 9.5 16.9202Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25032_20308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.314453)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueClock);
export default __webpack_public_path__ + "static/media/BlueClock.fd274d3e2906641c07ba671e4712023e.svg";
export { ForwardRef as ReactComponent };